import { useState } from "react";
import { PricingType } from "../data";
import styles from "./pricing.module.css"
import Pricing from "./Pricing";

interface PricingProps {
    pricing: PricingType[];
    user?: object;
}

// import Checkout from './Checkout'



const PricingGrid = ({ pricing, user }: PricingProps) => {

  const [paymentType, setPaymentType] = useState('year');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const onSelectProduct = (data) => { 

    
    setSelectedProduct(data)
  
  }

  return <>
      {/* <div  className={styles.SwitchContainer}>
          <button onClick={(e) => { setPaymentType('month'); }} style={{ marginRight: '5px' }} className={paymentType === 'month' ? styles.activeButton : ''}>Monthly</button>
          <button onClick={(e) => { setPaymentType('year'); }} className={paymentType === 'year' ? styles.activeButton : ''}>Annually</button>
      </div> */}
      <div className={styles.PricingWrapper}>
        {pricing.map((pricing: PricingType, i: number) => <Pricing onSelectProduct={onSelectProduct} key={i} pricing={pricing} pricingType={paymentType} />)}
      </div>
      <p className={styles.vatMessage}>All prices are exclusive of VAT</p>
    </>
}

export default PricingGrid;
